<template>
    <section class="container">
        <h3>Perfil</h3>
        <div class="row">
            <div class="col-12 col-md-12 col-lg-6">
                <div class="card shadow p-4" v-if="user">
                    <div class="row">
                        <!-- <div class="col-12 mb-3 text-right">
                            <button type="button" class="btn btn-primary" @click="toggleModal()">
                                <font-awesome-icon icon="plus" /> Actualizar datos 
                            </button>
                        </div> -->
                        <div class="col-12 col-md-12 col-lg-12">
                            <p>
                                <span v-if="user.displayName">
                                Nombre: <strong>{{user.displayName}}</strong>
                                </span>
                                <br />Correo: <strong>{{user.email}}</strong>
                            </p>
                            <div v-if="currentUser.signatureUrl" class="text-center">                     
                                <img class="preview w-50" :src="currentUser.signatureUrl">
                            </div>
                        </div>
                    </div>

                    <!-- <div class="row align-items-center">
                        <div class="col-3">
                            <img v-if="user.photoURL"
                                :src="user.photoURL"
                                class="rounded-circle"
                            />
                        </div>
                        <div class="col-9">
                            
                        </div>
                    </div> -->
                </div>
            </div>
            <div class="col-12 col-md-12 col-lg-6">
                <div class="shadow p-4">
                    <h3>Dibujar firma</h3>
                    <canvas id="sign-canvas" width="500" height="300" style="border:2px solid;margin-bottom:1rem"></canvas>

                    <div class="row justify-content-center">
                        <span class="btn btn-outline-info btn-sm mb-3" @click="onUpload()"><font-awesome-icon icon="cloud-upload-alt" /> Guardar</span>
                        <div class="progress mt-3" v-if="uploadValue > 0">
                            <div class="progress-bar progress-bar-striped bg-success" role="progressbar" :style="wStyle" :aria-valuenow="uploadValue" aria-valuemin="0" aria-valuemax="100"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import navigation from "@/components/NavBar.vue";
import firebase from "firebase/app"
import 'firebase/auth'
import 'firebase/storage'
import 'firebase/firestore'
import { mapGetters } from 'vuex'

export default {
    name: "Profile",
    data() {
        return {
            user: null,
            caption : '',
            imgUrl: '',
            imageData: null,
            uploadValue: 0,
            wStyle: "width:0",
            canvas: false,
            ctx: false,
            flag: false,
            prevX: 0,
            currX: 0,
            prevY: 0,
            currY: 0,
            dot_flag: false,
            strokeColor: "#333",
            lineWidth: 2,
            w: 0,
            h: 0,
            rect: false,
            message: ""
        }
    },
    computed: {
        ...mapGetters({
            currentUser: 'currentUser'
        })
    },
    created() {
        firebase.auth().onAuthStateChanged(user => {
            if (user) {
                this.user = user
            }
        })
    },
    mounted() {
        this.canvas = document.getElementById('sign-canvas')
        this.ctx = this.canvas.getContext("2d")
        this.rect = this.canvas.getBoundingClientRect()
        this.w = this.canvas.width
        this.h = this.canvas.height
    
        this.canvas.addEventListener("mousemove", (e) => {
            this.findxy('move', e)
        }, false)
        this.canvas.addEventListener("mousedown", (e) => {
            this.findxy('down', e)
        }, false)
        this.canvas.addEventListener("mouseup", (e) => {
            this.findxy('up', e)
        }, false)
        this.canvas.addEventListener("mouseout", (e) => {
            this.findxy('out', e)
        }, false)
    },
    methods: {
        previewImage(event) {
            this.uploadValue = 0
            this.imgUrl = null
            this.imageData = event.target.files[0]
            this.onUpload()
        },
        onUpload(){
            this.uploadValue = 0
            this.imgUrl = null
            this.message = this.canvas.toDataURL('image/png')
            const storageRef = firebase.storage().ref('managers_signatures').child(firebase.auth().currentUser.uid+'_sign.png').putString(this.message, 'data_url')
            
            storageRef.on(`state_changed`,snapshot=>{
                    this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100
                    this.wStyle = "width:"+this.uploadValue+"%"
                }, 
                error => {console.log(error.message)},
                () => {this.uploadValue=100
                        storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                            this.imgUrl = url
                            this.save()
                        })
                    }      
            )
        },
        click1() {
            this.$refs.input1.click()   
        },
        async save() {
            this.$store.commit("refreshActiveUser", {signatureUrl: this.imgUrl})
            let docRef = await firebase.firestore().collection("managers").doc(firebase.auth().currentUser.uid).set({
                signatureUrl: this.imgUrl,
                signatureBase64: this.message,
                createdAt: new Date()
            })
        },
        draw() {
            this.ctx.beginPath()
            this.ctx.moveTo(this.prevX, this.prevY)
            this.ctx.lineTo(this.currX, this.currY)
            this.ctx.strokeStyle = this.strokeColor
            this.ctx.lineWidth = this.lineWidth
            this.ctx.fillStyle = "#fefefe"
            this.ctx.stroke()
            this.ctx.closePath()
        },
        findxy(res, e) {
            if (res == 'down') {
                this.prevX = this.currX
                this.prevY = this.currY
                this.currX = parseInt(e.clientX - this.rect.left)
                this.currY = parseInt(e.clientY - this.rect.top)
        
                this.flag = true
                this.dot_flag = true
                if (this.dot_flag) {
                    this.ctx.beginPath()
                    this.ctx.fillStyle = this.x
                    this.ctx.fillRect(this.currX, this.currY, 2, 2)
                    this.ctx.closePath()
                    this.dot_flag = false
                }
            }
            if (res == 'up' || res == "out") {
                this.flag = false
            }
            if (res == 'move') {
                if (this.flag) {
                    this.prevX = this.currX
                    this.prevY = this.currY
                    this.currX = parseInt(e.clientX - this.rect.left)
                    this.currY = parseInt(e.clientY - this.rect.top)
                    this.draw()
                }
            }
        }
    }
};
</script>

<style scoped>
.shadow {
    background: #fff;
    -webkit-box-shadow: 0px 8px 20px rgba(0,0,0,0.06);
    box-shadow: 0px 8px 20px rgba(0,0,0,0.06);
    border-radius: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/Profile.vue